<template>
    <div>
        <h1>Update Password</h1>
        <form
            class="grid"
            novalidate
            @submit.prevent="updatePassword">
            <label
                class="reader-only"
                for="UpdatePasswordEmail">Email Address</label>
            <input
                autocomplete="email"
                id="UpdatePasswordEmail"
                name="UpdatePasswordEmail"
                type="hidden"
                :value="$store.state.userProfile.email_address">

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdatePasswordCurrent">Current Password</label>
                    <input
                        autocomplete="current-password"
                        autofocus
                        id="UpdatePasswordCurrent"
                        name="UpdatePasswordCurrent"
                        placeholder="Current Password"
                        type="password"
                        v-model.trim="currentPassword"
                        v-validate.disable="'required'"
                        :class="{ 'input--invalid': errors.has('UpdatePasswordCurrent') }">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdatePasswordCurrent')">{{ errors.first('UpdatePasswordCurrent') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdatePasswordNew">New Password (min 8 characters)</label>
                    <input
                        autocomplete="new-passsword"
                        id="UpdatePasswordNew"
                        name="UpdatePasswordNew"
                        placeholder="New Password (min 8 characters)"
                        ref="UpdatePasswordNew"
                        type="password"
                        v-model.trim="newPassword"
                        v-validate="'required|min:8'"
                        :class="{ 'input--invalid': errors.has('UpdatePasswordNew') }">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdatePasswordNew')">{{ errors.first('UpdatePasswordNew') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <label
                        class="reader-only"
                        for="UpdatePasswordConfirm">Confirm New Password</label>
                    <input
                        autocomplete="new-password"
                        id="UpdatePasswordConfirm"
                        name="UpdatePasswordConfirm"
                        placeholder="Confirm New Password"
                        ref="UpdatePasswordConfirm"
                        type="password"
                        v-validate.disable="'required|confirmed:UpdatePasswordNew'"
                        :class="{ 'input--invalid': errors.has('UpdatePasswordConfirm') }">
                    <span
                        class="error-message"
                        v-if="errors.has('UpdatePasswordConfirm')">{{ errors.first('UpdatePasswordConfirm') }}</span>
                </div>
            </div>

            <div class="grid__row">
                <div class="grid__col grid__col--100">
                    <button
                        class="submit"
                        type="submit"
                        :disabled="isUpdating">Change Password</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import errorHandleable from '../mixins/ErrorHandleable'
import quebecUserModal from '../mixins/QuebecUserModal'
import trackable from '../mixins/Trackable'

export default {
    beforeCreate () {
        this.htmlPageTitle = `Change your password at ${this.$config.partnerName}`
    },
    created () {
        this.trackPageView(this.$route.fullPath, this.htmlPageTitle)
    },
    data () {
        return {
            currentPassword: '',
            isUpdating: false,
            newPassword: ''
        }
    },
    head: {
        title () {
            return {
                inner: this.htmlPageTitle
            }
        }
    },
    methods: {
        updatePassword () {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) { return }

                    this.isUpdating = true

                    this.$marketplace
                        .changePassword(this.$store.state.userProfile.id, {
                            current_password: this.currentPassword,
                            new_password: this.newPassword
                        })
                        .then(response => {
                            this.currentPassword = ''
                            this.newPassword = ''
                            this.$refs.UpdatePasswordConfirm.value = ''

                            this.$validator.reset()

                            this.$notify({
                                text: 'Password has been changed.',
                                type: 'success'
                            })
                        })
                        .catch(err => this.catchAndNotify(err.errors))
                        .finally(() => {
                            this.isUpdating = false
                        })
                })
        }
    },
    mixins: [
        errorHandleable,
        quebecUserModal,
        trackable
    ]
}
</script>
